<template>
  <Row>
    <Col span="24">
      <Card>
        <p slot="title">
          <Icon type="ios-people"></Icon> 研究团队成员列表
        </p>

        <span slot="extra">
          <Select v-model="status" style="width:120px" @on-change="fetchData" placeholder="状态" clearable>
            <Option v-for="(status,key) in statuses" :value="key" :key="key">{{ status }}</Option>
          </Select>
          <Select v-model="role" style="width:120px" @on-change="fetchData" placeholder="角色" clearable>
            <Option v-for="(role,key) in roles" :value="key" :key="key">{{ role }}</Option>
          </Select>
          <Button type="success" @click="showAdd = true"><Icon type="md-add"></Icon> 邀请新成员</Button>
        </span>
        <Table :columns="attributes" :data="members"></Table>
        <pagination v-bind:meta="pageMeta" name="pagination" @refresh="refresh"></pagination>
      </Card>

      <Modal v-model="showAdd" :footer-hide="true" title="添加新成员">
          <add-member ref="addMember" @refresh="refresh"></add-member>
      </Modal>
      <Modal v-model="showEdit" title="编辑成员信息" :footer-hide="true">
          <edit-member ref="editMember" :meta="meta" @refresh="refresh"></edit-member>
      </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListMembers, GetAssistItems, DeleteMember } from '@/api/study.team'
import AddMember from '@/components/team/AddMember'
import EditMember from '@/components/team/EditMember'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'list-team',
  data: function () {
    return {
      members: [],
      showAdd: false,
      showEdit: false,
      status: '1',
      statuses: {},
      role: null,
      roles: {},
      meta: null,
      attributes: [
        {
          title: '角色',
          key: 'roleText'
        },
        {
          title: '姓名',
          key: 'username',
          render: (h, params) => {
            const avatar = params.row.user.name[0]
            const name = params.row.user.name + '( ' + params.row.user.email + ' )'
            return h('div', [
              h('Avatar', {
                props: {
                  size: 'small',
                  style: 'background-color: #05a294'
                }
              }, avatar),
              h('span', name)
            ])
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 120,
          render: (h, params) => {
            const icon = params.row.status === 1 ? 'ios-trash' : 'ios-refresh'
            return h('div', [
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small',
                  icon: 'ios-create-outline'
                },
                on: {
                  click: () => {
                    this.edit(params.row.id)
                  }
                }
              }),
              h('Button', {
                props: {
                  type: 'text',
                  size: 'small',
                  icon: icon
                },
                on: {
                  click: () => {
                    this.remove(params.row.id)
                  }
                }
              })
            ])
          }
        }
      ],
      pageMeta: {},
      model: ''
    }
  },
  created: function () {
    this.fetchData()
    this.getItems()
  },
  components: {
    'pagination': Pagination,
    'add-member': AddMember,
    'edit-member': EditMember
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['StudyTeamSearch[status]'] = this.status
      query['StudyTeamSearch[role]'] = this.role
      query['id'] = this.$route.params.id
      ListMembers(query).then(async res => {
        this.members = res.items
        this.pageMeta = res._meta
      })
    },
    getItems: function () {
      const id = this.$route.params.id
      GetAssistItems(id).then(async res => {
        this.statuses = res.statuses
        this.roles = res.roles
      })
    },
    refresh: function () {
      this.fetchData()
      this.showAdd = false
      this.showEdit = false
    },
    edit: function (id) {
      this.meta = id
      this.$refs.editMember.init(id)
      this.showEdit = true
    },
    remove: function (id) {
      DeleteMember(id).then(async res => {
        this.fetchData()
      })
    }
  }
}
</script>
